import React from 'react'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import LtsTextArea from '../../../components/lottus/lts-text-area'
import { InputText } from 'primereact/inputtext'
import { getMessage } from '../../../utils/index'
import { TIPOS, FORMATOS } from '../constants'
import './CrudIntegracaoForm.scss'

export const CrudIntegracaoForm = ({ record, changeHandler, messages, setField }) => (
  <div className="p-grid p-fluid">
    <div className="p-col-12">
      <div className="card card-w-title">
        <h3>
          {getMessage(messages, 'crudIntegracao.label.integracao')} {record.oid || ''}
        </h3>
        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
            <span className="p-float-label">
              <InputText value={record.nome} onChange={changeHandler} name="nome" />
              <label>{getMessage(messages, 'crudIntegracao.label.nome')}</label>
            </span>
          </div>
        </div>

        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
            <LtsDropdownUnidade
              name={'unidade'}
              label={getMessage(messages, 'crudIntegracao.label.unidade')}
              value={record.unidade}
              onChange={(e) => setField('unidade', e)}
              showOptionAll={false}
            />
          </div>
        </div>

        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
            <LtsDropdownIdValue
              name={'tipo'}
              value={record.tipo}
              onChange={(e) => setField('tipo', e)}
              options={TIPOS}
              label={getMessage(messages, 'crudIntegracao.label.tipo')}
            />
          </div>
        </div>

        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
            <LtsDropdownIdValue
              name={'formato'}
              value={record.formato}
              onChange={(e) => setField('formato', e)}
              options={FORMATOS}
              label={getMessage(messages, 'crudIntegracao.label.formato')}
            />
          </div>
        </div>

        <div>
          <br />
          <LtsTextArea
            style={{ minHeight: '200px' }}
            autoFocus={true}
            value={record.consultaSql}
            onChange={(e) => setField('consultaSql', e)}
            name={'consultaSql'}
            label={getMessage(messages, 'crudIntegracao.label.consultaSql')}
            cols={100}
          />
          <br />
        </div>

        <div>
          <LtsTextArea
            style={{ minHeight: '200px' }}
            autoFocus={true}
            value={record.requisicao}
            onChange={(e) => setField('requisicao', e)}
            name={'requisicao'}
            label={getMessage(messages, 'crudIntegracao.label.requisicao')}
            cols={100}
          />
        </div>
      </div>
    </div>
  </div>
)
